import { render, staticRenderFns } from "./popoverButton.vue?vue&type=template&id=3e7a1a52"
import script from "./popoverButton.vue?vue&type=script&lang=js"
export * from "./popoverButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/joinmc-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e7a1a52')) {
      api.createRecord('3e7a1a52', component.options)
    } else {
      api.reload('3e7a1a52', component.options)
    }
    module.hot.accept("./popoverButton.vue?vue&type=template&id=3e7a1a52", function () {
      api.rerender('3e7a1a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popoverButton.vue"
export default component.exports